// import React, { useState } from "react";
// import Carousel from "react-material-ui-carousel";
// import { Box, IconButton, Tooltip } from "@mui/material";
// import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
// import Upload from "../Upload";
// import { uploadType } from "../../containers/FlashCards/FlashCardQuestions/FlashCardForm/FlashCardForm";
// import MaterialPreview from ".";

// /* eslint-disable react/prop-types */
// function MaterialPreviewCarousel({
//   flashcardIndex,
//   answerIndex,
//   attachments = [], // flashcard_attachments_attributes
//   setFieldValue,
//   handleUploadSingleImage,
//   uploadRef,
//   type,
//   fieldPath = "",
//   uploadImageLabel,
//   mode
// }) {
//   const [activeStep, setActiveStep] = useState(0);
//   const isTypeAnswer = type === uploadType.answer;
//   const MAX_IMAGES = isTypeAnswer ? 1 : 4;
//   const handleClear = (positionIndex) => {
//     const updated = attachments
//       .filter((_, i) => i !== positionIndex)
//       .map((att, i) => ({ ...att, position: i })); // re-index positions
//     if (type === uploadType.question)
//       setFieldValue(
//         `flashcards[${flashcardIndex}].flashcard_attachments_attributes`,
//         updated
//       );

//     if (type === uploadType.justification)
//       setFieldValue(
//         `flashcards[${flashcardIndex}].flashcard_explanation_attributes.flashcard_attachments_attributes`,
//         updated
//       );

//     if (type === uploadType.answer)
//       setFieldValue(
//         `flashcards[${flashcardIndex}].flashcard_options_attributes[${answerIndex}].flashcard_attachments_attributes`,
//         updated
//       );

//     if (activeStep >= updated.length && activeStep > 0) {
//       // stay in bounds
//       setActiveStep((prev) => prev - 1);
//     }
//   };

//   const handleUpload = (e) => {
//     console.log("handleUpload e", type);
//     // your existing handler should push { path, position } to the array
//     if (type === uploadType.question)
//       handleUploadSingleImage(e, flashcardIndex, uploadType.question);
//     if (type === uploadType.justification)
//       handleUploadSingleImage(
//         e,
//         flashcardIndex,
//         uploadType.justification
//       );
//     if (type === uploadType.answer)
//       handleUploadSingleImage(e, answerIndex, uploadType.answer);
//   };

//   return (
//     <Box className="text-center">
//       {/* Carousel — only renders if there are images */}
//       {attachments.length > 0 && (
//         <>
//           <Carousel
//             index={activeStep}
//             onChange={(now) => setActiveStep(now)}
//             autoPlay={false}
//             animation="slide"
//             navButtonsAlwaysVisible={!isTypeAnswer}
//             navButtonsProps={{
//               style: {
//                 display:
//                   attachments.length === 1 ||
//                   type === uploadType.answer
//                     ? "none"
//                     : "flex"
//               }
//             }}
//             indicators={
//               attachments.length > 1 && type !== uploadType.answer
//             }
//             sx={{ width: "100%", height: "200px" }}
//           >
//             {attachments.map((att, i) => (
//               <Box
//                 key={i}
//                 className={`d-flex flex-column align-items-center`}
//                 sx={{ position: "relative" }}
//               >
//                 <MaterialPreview
//                   type={1}
//                   style={{ height: "150px" }}
//                   isPublic={false}
//                   src={att.path?.url || att.path} // url for edit mode, path for new uploads
//                   hasClear={false} // we handle clear ourselves below
//                 />

//                 {/* Clear button per image */}
//                 {mode !== "View" && (
//                   <Tooltip title="Remove image">
//                     <IconButton
//                       size="small"
//                       color="error"
//                       onClick={() => handleClear(i)}
//                     >
//                       <DeleteOutlineIcon fontSize="small" />
//                     </IconButton>
//                   </Tooltip>
//                 )}
//               </Box>
//             ))}
//           </Carousel>
//           {!isTypeAnswer && (
//             <p>
//               {`${activeStep + 1} ` + "OF" + ` ${attachments.length}`}
//             </p>
//           )}
//         </>
//       )}
//       {/* Single uploader — hidden once max reached or in View mode */}
//       {mode !== "View" && attachments.length < MAX_IMAGES && (
//         <Upload
//           ref={uploadRef}
//           onChange={handleUpload}
//           label={uploadImageLabel}
//           name={fieldPath}
//           accept="image/*"
//           isImage={true}
//           setFieldValue={setFieldValue}
//           isRequired={attachments.length === 0}
//           isMultiple={false}
//         />
//       )}
//     </Box>
//   );
// }

// export default MaterialPreviewCarousel;

import React, { useState } from "react";
import Carousel from "react-material-ui-carousel";
import { Box, IconButton, Tooltip } from "@mui/material";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import Upload from "../Upload";
import { uploadType } from "../../containers/FlashCards/FlashCardQuestions/FlashCardForm/FlashCardForm";
import MaterialPreview from ".";

/* eslint-disable react/prop-types */
function MaterialPreviewCarousel({
  flashcardIndex,
  answerIndex,
  attachments = [], // flashcard_attachments_attributes
  setFieldValue,
  handleUploadSingleImage,
  uploadRef,
  type,
  fieldPath = "",
  uploadImageLabel,
  mode
}) {
  const [activeStep, setActiveStep] = useState(0);
  const isTypeAnswer = type === uploadType.answer;
  const MAX_IMAGES = isTypeAnswer ? 1 : 4;

  // Only show non-destroyed attachments in the UI
  const visibleAttachments = attachments.filter(
    (att) => !att._destroy
  );
  const hasSingleAttachment = visibleAttachments.length === 1;

  const getFieldPath = () => {
    if (type === uploadType.question)
      return `flashcards[${flashcardIndex}].flashcard_attachments_attributes`;
    if (type === uploadType.justification)
      return `flashcards[${flashcardIndex}].flashcard_explanation_attributes.flashcard_attachments_attributes`;
    if (type === uploadType.answer)
      return `flashcards[${flashcardIndex}].flashcard_options_attributes[${answerIndex}].flashcard_attachments_attributes`;
  };

  const handleClear = (positionIndex) => {
    // `positionIndex` is the index within `visibleAttachments` (no destroyed items).
    // Map it back to the original `attachments` index so we mark the right one.
    let visibleCount = 0;
    let originalIndex = -1;
    for (let i = 0; i < attachments.length; i++) {
      if (!attachments[i]._destroy) {
        if (visibleCount === positionIndex) {
          originalIndex = i;
          break;
        }
        visibleCount++;
      }
    }

    // Re-index positions for non-destroyed items, mark the target as _destroy: true
    let visiblePos = 0;
    const updated = attachments.map((att, i) => {
      if (i === originalIndex) {
        return { ...att, _destroy: true };
      }
      if (!att._destroy) {
        return { ...att, position: visiblePos++ };
      }
      return att; // already destroyed — leave untouched
    });

    setFieldValue(getFieldPath(), updated);

    // Stay in bounds after the visible list shrinks
    const newVisibleCount = updated.filter((a) => !a._destroy).length;
    if (activeStep >= newVisibleCount && activeStep > 0) {
      setActiveStep((prev) => prev - 1);
    }
  };

  const handleUpload = (e) => {
    if (type === uploadType.question)
      handleUploadSingleImage(e, flashcardIndex, uploadType.question);
    if (type === uploadType.justification)
      handleUploadSingleImage(
        e,
        flashcardIndex,
        uploadType.justification
      );
    if (type === uploadType.answer)
      handleUploadSingleImage(e, answerIndex, uploadType.answer);
  };

  return (
    <Box className="">
      {/* Carousel — only renders non-destroyed images */}
      {visibleAttachments.length > 0 && (
        <>
          <Carousel
            index={activeStep}
            onChange={(now) => setActiveStep(now)}
            autoPlay={false}
            animation="slide"
            navButtonsAlwaysVisible={!isTypeAnswer}
            navButtonsProps={{
              style: {
                display:
                  hasSingleAttachment || isTypeAnswer
                    ? "none"
                    : "flex"
              }
            }}
            indicators={!hasSingleAttachment && !isTypeAnswer}
            sx={{ width: "100%", height: "200px" }}
          >
            {visibleAttachments.map((att, i) => (
              <Box
                key={att.id || i}
                className="d-flex flex-column align-items-center"
                sx={{ position: "relative" }}
              >
                <MaterialPreview
                  type={1}
                  style={{ height: "150px" }}
                  isPublic={false}
                  src={att.path?.url || att.path}
                  hasClear={false}
                />

                {/* Clear button per image */}
                {mode !== "View" && (
                  <Tooltip title="Remove image">
                    <IconButton
                      size="small"
                      color="error"
                      onClick={() => handleClear(i)}
                    >
                      <DeleteOutlineIcon fontSize="small" />
                    </IconButton>
                  </Tooltip>
                )}
              </Box>
            ))}
          </Carousel>
          {!isTypeAnswer && (
            <p>{`${activeStep + 1} OF ${
              visibleAttachments.length
            }`}</p>
          )}
        </>
      )}
      {/* Uploader — hidden in View mode or when max visible images reached */}
      {mode !== "View" && visibleAttachments.length < MAX_IMAGES && (
        <Upload
          ref={uploadRef}
          onChange={handleUpload}
          label={uploadImageLabel}
          name={fieldPath}
          accept="image/*"
          isImage={true}
          setFieldValue={setFieldValue}
          isRequired={false}
          isMultiple={false}
        />
      )}
    </Box>
  );
}

export default MaterialPreviewCarousel;
